import CADropdown from '@ds/components/containers/CADropdown'
import type { PackageType } from '@vuejs/services/packages/interfaces'
import { defineComponent, type PropType } from 'vue'

import type { ActionElements } from '@/javascript/interfaces'

import { stringToNumber } from '../packages/utils'

export default defineComponent({
	name: 'DataTableActions',

	props: {
		actions: { required: true, type: Array as PropType<ActionElements[]> },
		id: {
			required: true, type: [
				Number,
				String,
			] as PropType<number | string>,
		},
	},

	emits: { action: (_action: string, _type: PackageType | string, _id?: number | string) => true },

	computed: {
		convertedId(): number {
			return stringToNumber(this.id)
		},
	},

	methods: {
		handleOnActionClick(event: Event, action: string, type: PackageType | string) {
			event.stopPropagation()
			this.$emit('action', action, type, this.convertedId)
		},
	},

	render() {
		return (
			<CADropdown
				buttonDataTest="folder-options-dropdown"
				buttonStyle="text"
				onClick={(event?: Event): void => event?.stopPropagation()}
			>
				{{
					button: () => 'Options',

					default: () =>
						<ul role="menu">
							{this.actions?.map(action =>
								<a
									class={[
										`ca-dropdown__menu-item`,
										action.class,
									]}
									data-test={action.dataTest}
									href={action.link ? action.link : 'javascript:void(0)'}
									role="menuitem"
									v-tooltip={action.tooltip}
									onClick={(event): void => this.handleOnActionClick(event, action.text ?? '', action.type)}
								>
									{action.text}
								</a>
							)}
						</ul>,
				}}
			</CADropdown>
		)
	},
})
